var card_content_default = {
  "content": "-znmr",
  "textStart": "HwYRr",
  "contentText": "rXCCN",
  "subtitle": "liv8s",
  "pricing": "XVB2F",
  "titlePriceContainer": "_83V1o",
  "textCenter": "LyaC0",
  "textEnd": "_35AB5",
  "titlePriceSideBySide": "NTlBl",
  "titlePriceStacked": "H23Uz",
  "title": "_927-4",
  "price": "_1JXmR",
  "priceDiscounted": "delcQ",
  "priceOriginal": "_3OgCI",
  "priceStrikethrough": "qBsoK",
  "ribbon": "AsqBX",
  "button": "e93rc",
  "button_disabled": "q2-Dw",
  "buttonText": "_8UAfv",
  "framelessContent": "Fatiz",
  "framelessImageTop": "sZx8g",
  "framelessImageStart": "NX77y",
  "framelessImageEnd": "fiDe9"
};
export {
  card_content_default as default
};
//# sourceMappingURL=card-content-scss.js.map
